



















import {Component, Prop, Vue} from 'vue-property-decorator';
import MenuItem from '@/components/MenuItem.vue';

export type PageType = 'Home' | 'ExhibitorList' | 'ExhibitorInfo' | 'ParticipantInfo' | 'Announcement01';
@Component({
  components: {MenuItem},
})
export default class Menu extends Vue {
  @Prop({ type: String, required: true })
  private pageType!: PageType;

  @Prop({ type: Number, required: true })
  private sizeRatio!: number;

  private isView: boolean = false;

  private changeOpen() {
    this.isView = !this.isView;
  }

  private goto(target: string) {
    if (this.pageType === target) {
      this.changeOpen();
    }
  }
}
